import { useEffect } from 'react';

/**
 * @param {string} title - Desired value of `document.title`
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
